<template>
  <div class="db-header">
    <div class="db-header__title-wrap">
      <p class="db-header__eyebrow">Panel Analitico</p>
      <h2 class="db-header__title">Resumen financiero de CFDIs</h2>
      <p class="db-header__subtitle">{{ periodLabel }} | Modo: {{ reportTypeLabel }}</p>
    </div>

    <div class="db-header__actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardHeaderBar',
  props: {
    periodLabel: { type: String, default: '' },
    reportTypeLabel: { type: String, default: 'Facturado' },
  },
};
</script>

<style scoped>
.db-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 1.1rem 1.2rem;
  border-radius: 16px;
  border: 1px solid rgba(115, 102, 255, 0.22);
  background: linear-gradient(135deg, rgba(115, 102, 255, 0.08) 0%, rgba(247, 49, 100, 0.06) 100%);
  margin-bottom: 1rem;
}

.db-header__eyebrow {
  margin: 0;
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 0.08em;
  font-weight: 700;
  color: var(--theme-deafult);
}

.db-header__title {
  margin: 0.15rem 0 0;
  font-family: Poppins, "Segoe UI", sans-serif;
  font-size: 1.35rem;
  font-weight: 700;
  color: #2f2f3b;
}

.db-header__subtitle {
  margin: 0.2rem 0 0;
  font-size: 12px;
  color: #486272;
}

.db-header__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.65rem;
}

@media (max-width: 768px) {
  .db-header {
    flex-direction: column;
    align-items: stretch;
  }

  .db-header__actions {
    justify-content: flex-start;
  }
}
</style>
